import { useContext } from 'react';
import {
  DeleteModal,
  ModalContext,
  PaginationContext,
} from 'dash-ui';

import {
  GetPropertyNotesDocument,
  useRemovePropertyNoteMutation,
} from 'gql/generated.graphql';

function DeletePropertyNoteModal({ propertyId }: { propertyId: string }) {
  const { state: paginationState, getRefetchProps } =
    useContext(PaginationContext);
  const { skip, limit } = getRefetchProps(paginationState);

  const { payload } = useContext(ModalContext);

  const [removePropertyNote, { loading }] = useRemovePropertyNoteMutation({
    refetchQueries: [
      {
        query: GetPropertyNotesDocument,
        variables: {
          propertyId,
          pagination: { skip, limit },
        },
      },
    ],
  });

  async function submitPropertyDelete() {
    await removePropertyNote({
      variables: { propertyNoteId: payload.propertyNoteId },
    });
  }

  return (
    <DeleteModal
      entity="Property Note"
      name={payload?.propertyNoteId}
      isLoading={loading}
      modalName="DeletePropertyNoteModal"
      onClick={submitPropertyDelete}
      colorVariation="danger"
    />
  );
}

export default DeletePropertyNoteModal;
